module.exports = __webpack_public_path__ + "pb-logo-59373d3897242e0050f03865e29d4ece.webp";